/** @file POSE_FLAGS: the bits of the `flags` column of a PoseBuffer (ruling R2). */

/**
 * Bits of `POSE_LAYOUT.flags`: `hidden` (1) the node draws nothing this frame; `rotToggle` (2) the key inverts the
 * picked entry's rotate rule (18.10); `yawFlipped` (4) the node's pitch is beyond +-90 degrees (entries flagged
 * `yawFlip` look up azimuth + 180 on the FLIP twin, 18.4). The node's frame key sits in bits 8-15:
 * `(flags >> frameKeyShift) & frameKeyMask`, values 0-255.
 */
export const POSE_FLAGS = { hidden: 1, rotToggle: 2, yawFlipped: 4, frameKeyShift: 8, frameKeyMask: 0xff } as const;
